export default __webpack_public_path__ + "content/media/35.7690d517.jpg";